<div mat-dialog-title>{{ data?.header }}</div>
<div class="mat-dialog-container">
  <mat-dialog-content>
    <button mat-button class="close-icon" [mat-dialog-close]="true"><mat-icon>close</mat-icon></button>
    <app-dynamic-data-table [DataTableSchema]="dataTableSchema"></app-dynamic-data-table>
  </mat-dialog-content>
</div>
